var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('impact-section-page',{attrs:{"section-id":_setup.IMPACT_SECTION_IDS.growthFactor,"context":_setup.TemplateEngineContext.ImpactSolution,"title":_setup.growthFactorTitle,"impact-goal":_vm.impactGoal,"impact":_vm.impact,"impact-solution":_vm.impactSolution,"rounded":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }